import React from "react";
import { Grid, Container, FormControlLabel, Box, Typography } from "@mui/material";
import SubscriptionCard from "./SubscriptionCard";
import apiService from "../../service";
import { Radio } from '@mui/material';
import './Subscription.css';
import { useLocation, useNavigate } from "react-router-dom";
import TrustImage from "../../assets/TrustImage.png"
import SubscriptionFailed from "./SubscriptionFailed"
import { useParams } from "react-router-dom";




const SubscriptionPlans = () => {
    const [selectedCurrency, setSelectedCurrency] = React.useState("USD");
    const [subscriptionDatas, setSubscriptionDatas] = React.useState([])
    const location = useLocation();
    const navigate = useNavigate();
    const handleCurrencyChange = (event) => {
        setSelectedCurrency(event.target.value);
    };
    const { id } = useParams();
    const locationpath = location.pathname.startsWith(`/cancel/${id}`)

    React.useEffect(() => {
      const userType = localStorage.getItem('userType');
      if(userType === "prepaid"){
        const fetchSubscriptions = async () => {
            try {
                const subscriptionResp = await apiService.getProductList();
                if (subscriptionResp.status_code === 200) {
                    setSubscriptionDatas(subscriptionResp.data);
                }
            } catch (error) {
                console.error("Error fetching subscriptions:", error);
            }
        };

        fetchSubscriptions();
      }else{
        navigate('/my-usage');
      }
    }, [navigate]);

    return (
        <div className="subscription-container">
            <Grid xs={12} container spacing={2}>
            <Grid item xs={12} md={6}>
                <Typography variant="h4" gutterBottom className='subscription-text'>
                Plans & Pricing
                </Typography>
                <Typography variant="h6" gutterBottom className='subscription-description'>
                Affordable Plans for Individuals & Teams – Upgrade Anytime.
                </Typography>
                <Box className="trust-container">
                    <img src={TrustImage
                    } alt="TrustImage" className="trust-image" />   
                    <Typography variant="h6" gutterBottom className='subscription-trust'>
                    Trusted by 10,000+ users   
                    </Typography>
                </Box>
            </Grid>
            {/* Currency Radio */}
            {/* <Grid item xs={12} md={6} className="currencySelector">
                <Box className="currency-text-container">
                    <Typography variant="h6" gutterBottom className='currency-text'>
                            Please select your currency:
                    </Typography>
                </Box>
                <Box>
                    <FormControlLabel
                        className="formLabelcountries"
                        value="INR"
                        checked={selectedCurrency === "INR"}
                        control={<Radio />}
                        onChange={handleCurrencyChange}
                        label={
                            <Box className="flag-container">
                                <img
                                    src="https://flagcdn.com/w40/in.png"
                                    alt="INR"
                                    className='flag-icon'
                                />
                                <Typography className="flag-text">INR</Typography>
                            </Box>
                        }
                    />

                    <FormControlLabel
                        className="formLabelcountries"
                        value="USD"
                        checked={selectedCurrency === "USD"}
                        control={<Radio />}
                        onChange={handleCurrencyChange}
                        label={
                            <Box className="flag-container">
                                <img
                                    src="https://flagcdn.com/w40/us.png"
                                    alt="USD"
                                    className='flag-icon'
                                />
                                <Typography className="flag-text">US DOLLAR</Typography>
                            </Box>
                        }
                    />

                    <Box>
                        <Typography className='payment-text'>
                        Payment will be processed through Razorpay and UPI 
                        </Typography>
                    </Box>
                </Box>
            </Grid> */}
            
            </Grid>
            {!locationpath ? (
                <Grid container spacing={1} sx={{ mt: 2 }}>
                    {subscriptionDatas.map((plan) => (
                        <SubscriptionCard
                            key={plan._id}
                            plan={plan}
                            selectedCurrency={selectedCurrency}
                        />
                    ))}
                </Grid>
            ) : (
                <SubscriptionFailed />
            )}
        </div>

    );
};

export default SubscriptionPlans;
